import { createContext, useContext } from 'react';

export interface TourContextValue {
  /** The current page has a tour. */
  available: boolean;
  /** A tour is on screen (or loading). */
  running: boolean;
  /** The current page's tour has been finished or closed before, on this device. */
  seen: boolean;
  start: () => void;
}

export const TourContext = createContext<TourContextValue>({
  available: false,
  running: false,
  seen: true,
  start: () => {},
});

export const useTour = () => useContext(TourContext);
